import type { HeaderType } from './constant'
import { HeaderKeysMap, SettingHeaderMap, SettingSortMap, UnSelectKeysMap } from './constant'

export interface ColumnKey {
  column: string
  isSelect: boolean
}

export function formatKeys(columnList: ColumnKey[], type: HeaderType) {
  columnList = columnList || []
  const clientHeaderKeys = HeaderKeysMap[type]
  const unSelectKeys = UnSelectKeysMap[type]
  // 排序列表
  const sortKeys = columnList.map((item) => item.column)
  // 勾选列
  const selectKeys = columnList?.filter((item) => !!item?.isSelect).map((item) => item.column)
  // 兼容前端后期新增的列,不在初始返回的数据中
  const salesExtra = clientHeaderKeys.filter((item) => !sortKeys.includes(item))
  // 过滤掉不默认勾选的key
  const extraSelectKeys = salesExtra.filter((item) => !unSelectKeys.includes(item))
  if (salesExtra.length > 0) {
    sortKeys.push(...salesExtra)
  }
  if (extraSelectKeys.length > 0) {
    selectKeys.push(...extraSelectKeys)
  }
  return {
    [SettingHeaderMap[type]]: selectKeys,
    [SettingSortMap[type]]: sortKeys,
  }
}
